import { render } from "./AdminsCreating.vue?vue&type=template&id=ff5c7078&ts=true"
import script from "./AdminsCreating.vue?vue&type=script&lang=ts"
export * from "./AdminsCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__